export default __webpack_public_path__ + "static/media/honesty2Img3.ecc65cf9.png";